export const NAME = 'producedProduction-reported';

export const dialogs = {
	documentRecordsLimit: 'documentRecordsLimit',
};
